import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../../../../environments/environment";
import { ResponseGeneralInterface } from "../../../../../core/interfaces/response/response-general.interface";
import { Observable } from "rxjs";
import { AuthService } from "../../../../../core/service/auth.service";

@Injectable({
  providedIn: "root",
})
export class DeleteAccountService {
  private apiUrl = environment.apiUrl
  constructor(private http: HttpClient,
    private authService: AuthService
  ) { }

  deleteAccount(): Observable<ResponseGeneralInterface> {
    const headers = {
      'Authorization': `Bearer ${this.authService.getToken()}`
    }
    return this.http.post<ResponseGeneralInterface>(`${this.apiUrl}/confirmationEmailCode`, {}, { headers });
  }
}
